import { defineStore } from 'pinia';

export const useNavViewTypeStore = defineStore('navViewType', {
  state: () => ({
    viewType: null,
  }),
});
